import { render, staticRenderFns } from "./BCXDatePickerMonth.vue?vue&type=template&id=f95ff06c"
import script from "./BCXDatePickerMonth.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXDatePickerMonth.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXDatePickerMonth.vue?vue&type=style&index=0&id=f95ff06c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports